// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-layout {\n  min-height: 100%;\n}\n.default-header {\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/layouts/DefaultLayout.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAEA;EACE,YAAA;AAAF","sourcesContent":[".default-layout {\n  min-height: 100%;\n}\n\n.default-header {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
